import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/wpbeginner': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M462.8 322.4c56.2 64.3 4.2 157.6-91.9 157.6-39.6 0-78.8-17.7-100.1-50-6.9 0.4-22.7 0.4-29.6 0-21.4 32.4-60.6 50-100.1 50-95.5 0-148.3-93-91.9-157.6-79.1-131.9 31.3-290.4 206.8-290.4 175.6 0 285.9 158.6 206.8 290.4zM123.2 239.4h41.5v-58.1h-41.5v58.1zM340.3 325.5v-23.8c-60.5 20.9-132.4 9.2-187.6-34l0.2 24.9c51.1 46.4 131.7 57.9 187.3 32.9zM189.6 239.4h166.1v-58.1h-166.1v58.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/wpbeginner.js
// module id = 1098
// module chunks = 0